// removed by extract-text-webpack-plugin
module.exports = {"base":"Panel_base--339ST","isActive":"Panel_isActive--32Lcj","isDemo":"Panel_isDemo--1TxWf","inner":"Panel_inner--373ee"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Panel/Panel.css
// module id = 1827
// module chunks = 16